import jsPDF from 'jspdf';

// Function to convert image URL to Base64
const getBase64ImageFromUrl = async (imageUrl) => {
  try {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Error fetching image:', error);
    return null;
  }
};

const exportToPdf = async (bikeData) => {
  const { logs } = bikeData;
  const bikeName = `${bikeData?.specs.make} ${bikeData?.specs.model ? bikeData?.specs.model : ""}`;
  const bikeVIN = bikeData?.dashboard.VIN;
  const bikeRegistration = bikeData?.dashboard.registration;

  // Initialize jsPDF
  const doc = new jsPDF();

  // Define the background color
  const pageBackgroundColor = [30, 30, 40]; // RGB for #20212C

  // Set initial positioning variables
  const marginX = 20;
  let startY = 40;

  // Add a full-page background color
  const addBackground = () => {
    doc.setFillColor(...pageBackgroundColor);
    doc.rect(0, 0, doc.internal.pageSize.getWidth(), doc.internal.pageSize.getHeight(), 'F'); // Fill entire page with background color
  };

  // Function to add header on every page
  const addHeader = () => {
    const logoBase64 = 'data:image/png;base64,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'; // Your Base64 logo
    const logoWidth = 70; // Adjust width as needed
    const logoHeight = 10; // Adjust height as needed
    doc.addImage(logoBase64, 'PNG', marginX, 13, logoWidth, logoHeight);

    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(255, 255, 255);
    doc.text(bikeName, doc.internal.pageSize.getWidth() - marginX - doc.getTextWidth(bikeName), 20);

    // Add bike VIN and Registration under the bike name
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(150, 150, 150); // Grey color for VIN and registration
    if (bikeVIN) {
      doc.text(`VIN: ${bikeVIN}`, doc.internal.pageSize.getWidth() - marginX - doc.getTextWidth(`VIN: ${bikeVIN}`), 28);
    }
    if (bikeRegistration) {
      doc.text(`Registration: ${bikeRegistration}`, doc.internal.pageSize.getWidth() - marginX - doc.getTextWidth(`Registration: ${bikeRegistration}`), 34);
    }
  };

  // Add initial background and header
  addBackground();
  addHeader();

  // Define background color for cards
  const cardBackgroundColor = [43, 44, 55]; // Dark background color

  // Iterate through logs and add details along with images
  for (const log of logs) {
    // Check if all photos in the log are verified and if there are photos
    const allPhotosVerified = log.photos && log.photos.length > 0 && log.photos.every(photo => photo.isVerified);

    // Split text into lines for dynamic height calculation
    const notesLines = doc.splitTextToSize(log.notes || '', 150); // Wrap notes text
    const notesHeight = notesLines.length * 6; // Calculate height based on lines (adjust line height)

    // Calculate height required for tasks
    let tasksHeight = 0;
    if (log.tasks && log.tasks.length > 0) {
      log.tasks.forEach((task) => {
        const taskLines = doc.splitTextToSize(task.taskDesc, 140); // Wrap task text
        tasksHeight += taskLines.length * 6; // Add height for each task line
      });
    } else {
      tasksHeight = 10; // Space for "No tasks available"
    }

    // Calculate the height needed for the images section
    let imagesHeight = 0;
    if (log.photos && log.photos.length > 0) {
      const imageSize = 45; // Square size of each image
      const imagesPerRow = 3; // Number of images per row
      const rows = Math.ceil(log.photos.length / imagesPerRow); // Calculate the number of rows needed
      imagesHeight = rows * (imageSize + 5); // Total height including padding between rows
    }

    // Calculate total card height dynamically after positioning notes and photos
    const dynamicCardHeight = 60 + notesHeight + tasksHeight + imagesHeight;
    const extraPadding = 20; // Extra padding for the bottom of the card
    const verifiedTitlePadding = allPhotosVerified ? 13 : 0; // Additional height for the "Verified Log" title
    let cardHeight = dynamicCardHeight + verifiedTitlePadding + extraPadding; // Adjust the card height based on content and padding

    // Check if log fits on current page, if not, add a new page
    const availableSpace = doc.internal.pageSize.getHeight() - startY - 20; // Space left on the page
    if (cardHeight > availableSpace) {
      doc.addPage();
      addBackground();
      addHeader();
      startY = 40; // Reset start position for new page
    }

    // Draw the card background
    doc.setFillColor(...cardBackgroundColor);
    doc.roundedRect(marginX, startY, 170, cardHeight, 3, 3, 'F');

    // Add "Verified Log" title if all photos are verified
    if (allPhotosVerified) {
      doc.setFontSize(16);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(21, 220, 77); // Set text color to #15DC4D
      doc.text('Verified Log', marginX + 10, startY + 15); // Position the title at the top of the card
    }

    // Set font sizes and styles for text inside the card
    doc.setFontSize(15);
    doc.setTextColor(255, 255, 255);

    // Date (bold)
    const textX = marginX + 10;
    let textY = startY + (allPhotosVerified ? 25 : 15); // Adjust starting Y position if the "Verified Log" title is present
    doc.setFont('helvetica', 'bold'); // Set font to bold
    doc.text(`${log.date || 'N/A'}`, textX, textY);

    // Set all other text to font size 13
    doc.setFontSize(13);
    doc.setTextColor(150, 150, 150); // Set body text color to grey

    // Mileage
    doc.setFont('helvetica', 'normal'); // Reset to normal for other text
    doc.text(`${log.mileage ? log.mileage + ' miles' : 'Mileage: N/A'}`, textX, textY + 8);

    // Cost and Dealer (bold titles)
    doc.setFont('helvetica', 'bold'); // Set font to bold
    doc.setTextColor(255, 255, 255); // Set title text color to white
    doc.text(`Cost: £${log.cost || 'N/A'}`, textX, textY + 20);
    doc.text(`Completed by Dealer:`, textX + 90, textY + 20);
    doc.setFont('helvetica', 'normal'); // Set font to normal
    doc.setTextColor(150, 150, 150); // Set body text color to grey
    doc.text(`${log.completedByShop ? 'Yes' : 'No'}`, textX + 139, textY + 20);

    // Tasks section
    doc.setFont('helvetica', 'bold'); // Set font to bold
    doc.setTextColor(255, 255, 255); // Set title text color to white
    doc.text('Tasks:', textX, textY + 30);
    doc.setFont('helvetica', 'normal'); // Set font to normal
    doc.setTextColor(150, 150, 150); // Set body text color to grey
    let currentTaskY = textY + 38; // Initialize position for tasks
    if (log.tasks && log.tasks.length > 0) {
      log.tasks.forEach((task) => {
        const taskLines = doc.splitTextToSize(task.taskDesc, 140);
        taskLines.forEach((line) => {
          doc.text(`• ${line}`, textX + 5, currentTaskY, { maxWidth: 150 });
          currentTaskY += 6;
        });
      });
    } else {
      doc.text('No tasks available', textX + 5, currentTaskY);
    }

    // Notes section
    const notesStartY = currentTaskY + 10;
    doc.setFont('helvetica', 'bold'); // Set font to bold
    doc.setTextColor(255, 255, 255); // Set title text color to white
    doc.text('Notes:', textX, notesStartY);
    doc.setFont('helvetica', 'normal'); // Set font to normal
    doc.setTextColor(150, 150, 150); // Set body text color to grey

    let calculatedNotesHeight = 0;
    if (log.notes) {
      doc.setFontSize(13);
      // Calculate the height of the notes by counting the number of lines
      const notesLines = doc.splitTextToSize(log.notes, 150);
      calculatedNotesHeight = notesLines.length * 6; // Calculate the height based on the number of lines
      doc.text(notesLines, textX, notesStartY + 8, { maxWidth: 150 });
    } else {
      doc.text('No additional notes.', textX, notesStartY + 8);
      calculatedNotesHeight = 8; // Set a minimum height when no notes are present
    }

    // Position photos after calculating the total height of the notes section
    let imageY = notesStartY + calculatedNotesHeight + 10; // Adjust starting Y position for photos based on notes height
    let imageX = textX + 3; // Initial X position for images
    const containerSize = 45; // Set container size (square dimensions)
    const imagesPerRow = 3; // Number of images per row
    const containerBackgroundColor = [62, 63, 78]; // RGB for #3e3f4e
    const verifiedBorderColor = [21, 220, 77]; // RGB for #15DC4D

    // Add images in a 3-column layout, wrapping to new lines if necessary
    if (log.photos && log.photos.length > 0) {
      for (let i = 0; i < log.photos.length; i++) {
        const imageObj = log.photos[i];
        try {
          const imageBase64 = await getBase64ImageFromUrl(imageObj.smallImageURL);
          console.log(imageBase64)
          // Load the image to calculate its aspect ratio and fit it correctly
          const img = new Image();
          img.src = imageBase64;

          // Adjust the aspect ratio calculation and image drawing section
          await new Promise((resolve) => {
            img.onload = () => {
              // Calculate aspect ratio
              const aspectRatio = img.width / img.height;
              let drawWidth, drawHeight, offsetX, offsetY;

              // Determine whether the image should fit by width or height
              const imagePadding = 2; // Padding to prevent overlap with the border
              if (aspectRatio > 1) {
                // Image is wider than tall, fit by width
                drawWidth = containerSize - imagePadding * 2; // Adjust width
                drawHeight = (containerSize - imagePadding * 2) / aspectRatio; // Adjust height
                offsetX = imagePadding;
                offsetY = (containerSize - drawHeight) / 2; // Center vertically
              } else {
                // Image is taller than wide, fit by height
                drawWidth = (containerSize - imagePadding * 2) * aspectRatio; // Adjust width
                drawHeight = containerSize - imagePadding * 2; // Adjust height
                offsetX = (containerSize - drawWidth) / 2; // Center horizontally
                offsetY = imagePadding;
              }

              // Set the fill color to #3e3f4e
              doc.setFillColor(...containerBackgroundColor);

              // Draw the square container background
              doc.roundedRect(imageX, imageY, containerSize, containerSize, 2, 2, 'F');

              // Draw a border if the image is verified
              if (imageObj.isVerified) {
                doc.setLineWidth(1); // Set the border width to 1px
                doc.setDrawColor(...verifiedBorderColor); // Set border color to #15DC4D
                doc.roundedRect(imageX, imageY, containerSize, containerSize, 2, 2, 'S'); // Draw the border
              }

              // Add the image within the calculated square, maintaining aspect ratio and cropping overflow
              doc.addImage(
                imageBase64,
                'PNG',
                imageX + offsetX,
                imageY + offsetY,
                drawWidth,
                drawHeight
              );

              // Move X position for the next image
              imageX += containerSize + 5; // Add spacing between images

              // Check if the next image should start a new row
              if ((i + 1) % imagesPerRow === 0) {
                imageX = textX + 3; // Reset X position to the start
                imageY += containerSize + 5; // Move Y position down for a new row of images
              }

              resolve();
            };
            img.onerror = resolve; // Resolve on error to avoid breaking the loop
          });

        } catch (error) {
          console.error('Failed to load image:', error);
        }
      }
    }

    // Move to next card position
    startY += cardHeight + 10; // Add spacing between cards
  }

  // Save the PDF
  doc.save('maintenance_log.pdf');
};

export { exportToPdf };
